import { MessageWidgetConfigContextType } from "@closerplatform/spinner-openapi";

export const getMessageWidgetIcon = (type: MessageWidgetConfigContextType | undefined): string => {
    switch (type) {
        case MessageWidgetConfigContextType.PredefinedMessageForm: return "icon-send-message";
        default: return "icon-doc";
    }
};
